(function () {
  "use strict";

  var mfDirectivesModules = angular.module('trainerWebApp.directives');

  mfDirectivesModules.directive('mfFullHeight', ['$window', function ($window) {
    return {
      link: function (scope, element, attrs) {
        var win = angular.element($window);
        var foot = angular.element(attrs.mfFullHeight);

        var resizeThrottle = _.throttle(onResize, 250);

        function naner(v) {
          v = parseInt(v);
          return isNaN(v) ? 0 : v;
        }

        function onResize() {
          if (element.css('display') == 'none') {
            return;
          }

          if (!foot.length)
            return;

          var elemExtent = element.offset().top + element.outerHeight();
          var footTop = foot.offset().top;

          //Handle margin collapse
          elemExtent += Math.max(naner(element.css('margin-bottom')), naner(foot.css('margin-top')));
          var deltaY = footTop - elemExtent - 1;

          if (deltaY) {
            //There is a bug in jquery .height if you use border-box. Workaround is to read/write with raw css height
            var h = parseInt(element.css('height') || '0');
            h += deltaY;

            element.css('height', h);

            scope.$broadcast('resized');
          }
        }

        // trigger an initial resize
        setTimeout(function () {
          win.trigger('resize');
        }, 50);

        win.on('resize', resizeThrottle);

        scope.$on('$destroy', function () {
          win.off('resize', resizeThrottle);
        });
      }
    }
  }]);

  mfDirectivesModules.directive('mfRepeaterTooltip', [function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.tooltip({placement: "top"});
      }
    }
  }]);

  /*http://mf-tms-app-qa.s3-website-us-west-2.amazonaws.com/?sessionId=1610752548#/series/1611089987/manage*/
  mfDirectivesModules.directive('ngSelect', ['$timeout', function ($timeout) {
    return {
      link: function (scope, element, attrs) {
        scope.$watch(attrs.ngSelect, function (val) {
          if (angular.isDefined(val) && val) {
            $timeout(function () {
              element[0].select();
              if (document.createEventObject) {
                var evt = document.createEventObject();
                element[0].fireEvent('onselect', evt);
              } else {
                var evt = document.createEvent("HTMLEvents");
                evt.initEvent('select', true, true);
                element[0].dispatchEvent(evt);
              }
            });
          }
        });

        // TODO: implement reverse
      }
    };
  }]);

  mfDirectivesModules.directive('ngSelected', ['$window', function ($window) {
    return {
      link: function (scope, element, attrs) {
        function getSelection() {
          return element[0].value.substring(
            element[0].selectionStart,
            element[0].selectionEnd
          );
        }

        element.bind('select', function () {
          scope.$apply(function () {
            scope[attrs.ngSelected] = getSelection();
          });
        });

        element.bind('blur', function () {
          scope.$apply(function () {
            scope[attrs.ngSelected] = "";
          });
        });

        // TODO implement for unselect
      }
    };
  }]);

  mfDirectivesModules.directive('mfWaitFor', ['$timeout', function ($timeout) {
    return {
      link: function (scope, element, attrs) {
        var functionName = attrs['mfWaitFor'];

        scope[functionName] = function (selector, maxTries, interval, cb) {
          var triesLeft = maxTries;

          function check() {
            if (element.children(selector).length > 0) {
              cb();
            }
            else {
              triesLeft--;
              if (triesLeft <= 0)
                return;
              $timeout(check, interval);
            }
          }

          check();
        };
      }
    };
  }]);

  mfDirectivesModules.directive('mfChangeDate', ['$parse', function ($parse) {
    return {
      link: function (scope, element, attr) {
        var fn = $parse(attr['mfChangeDate']);
        var now = new Date(Date.now());
        var startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
        startDate.setMinutes(startDate.getMinutes() - startDate.getTimezoneOffset()); // Make it the date we just set in UTC
        element.datepicker({startDate: startDate, activeHighlight: false});
        element.datepicker().bind('changeDate', function (event) {
          scope.$apply(function () {
            fn(scope, {
              $event: event
            });
            element.datepicker('hide');
          });
        });
      }
    };
  }]);

  mfDirectivesModules.directive('mfCarousel', function () {
    return {
      link: function (scope, element, attrs) {

        setTimeout(function () {
          var options = scope.$eval(attrs.mfCarousel) || {};
          element.jcarousel({
            auto: options.auto,
            wrap: options.wrap,
            vertical: options.vertical,
            scroll: options.scroll,
            animation: options.animation || 'fast',
            initCallback: mycarousel_initCallback,
            itemFallbackDimension: options.itemFallbackDimension || 300,
            visible: options.visible || null,
            buttonNextHTML: options.buttonNextHTML || null,
            buttonPrevHTML: options.buttonPrevHTML || null
          });

        }, 500);
        function mycarousel_initCallback(carousel) {
          carousel.clip.hover(carousel.stopAuto(), carousel.startAuto());
        }
      }
    };
  });

  mfDirectivesModules.directive('mfDropdownTip', ['$timeout', function ($timeout) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function postLink(scope, element, attrs, controller) {
        var options = scope.$eval(attrs.mfDropdownTip) || {};
        var tipContainer = $(options.container);
        $timeout(refresh, 1000);

        if (controller) {
          scope.$watch(attrs.ngModel, function (newValue, oldValue) {
            if (newValue !== oldValue) {
              element.selectpicker('refresh');
              $timeout(refresh);

              var txt = _.find(options.tips, function (value) {
                return value.id == newValue;
              });

              if (txt && txt.tip)
                tipContainer.text(txt.tip);
            }
          });
        }

        function refresh() {
          element.parent().find('.dropdown-menu').mouseleave(function () {
            var selectedTxt = $(this).children('.selected').text();
            var txt = _.find(options.tips, function (value) {
              return value.name == selectedTxt;
            });

            if (txt && txt.tip)
              tipContainer.text(txt.tip);
          });

          element.parent().find('li').mouseenter(function () {
            var txt = _.find(options.tips, function (value) {
              return value.name == $(this).text();
            }, this);

            if (txt && txt.tip)
              tipContainer.text(txt.tip);
          });
        }
      }
    };
  }]);

  mfDirectivesModules.directive('mfFadeinout', ['$timeout', function ($timeout) {
    return {
      restrict: 'A',
      scope: {
        mfFadeinout: '='
      },
      link: function postLink(scope, element) {
        scope.$watch('mfFadeinout', function (value) {
          if (value) {
            element.fadeIn('400', function () {
              $timeout(function () {
                element.fadeOut();
                scope.mfFadeinout = false;
              }, 2000);
            });
          }
        });
      }
    };
  }]);

  mfDirectivesModules.directive('mfKeyDown', ['$parse', function ($parse) {
    return function (scope, element, attr) {
      element.bind("keydown", function (event) {
        var fn = $parse(attr['mfKeyDown']);
        scope.$apply(function () {
          fn(scope, {
            $event: event
          });
        });
      });
    };
  }]);

  mfDirectivesModules.directive('mfFocusWhen', ['$parse', '$timeout', function ($parse, $timeout) {
    return function (scope, element, attrs) {
      var expression = $parse(attrs.mfFocusWhen);
      scope.$watch(expression, function (newValue) {
        $timeout(function () {
          newValue && element[0].focus();
        });
      }, true);
    };
  }]);

  mfDirectivesModules.directive('mfScrollWhen', ['$timeout', function ($timeout) {
    return function (scope, elem, attrs) {
      var domElem = elem[0];
      scope.$watch(attrs.mfScrollWhen, function (newValue) {
        if (!newValue) return;
        $timeout(function () {
          //Manually set scroll position, otherwise the browser might scroll the page instead of the containing div.
          //Just make sure the parent has layout (position absolute or relative)
          if (domElem && domElem.parentNode)
            domElem.parentNode.scrollTop = domElem.offsetTop - 20;
        });
      }, true);
    };
  }]);

  mfDirectivesModules.directive('mfSearchBox', ['$parse', function ($parse) {
    return {
      restrict: 'A',
      template: '<div class="search-box"><input type="text" id="search" ng-change="searchChanged()"  placeholder="{{placeholder}}" ng-model="search">' +
      '<i class="icon-search muted search-accent" ng-hide="search"></i>' +
      '<i class="icon-remove-sign close search-accent" ng-show="search" ng-click="search=null"></i></div>',
      scope: {
        search: '=',
        placeholder: '@placeholder'
      },
      replace: true
    };
  }]);

  mfDirectivesModules.directive('mfRowWithCount', function () {
    return {
      link: function postLink(scope, element, attrs) {
        var width = parseInt(element.css('width'));
        var maxWidth = parseInt(element.css('max-width'));
        if (width && maxWidth)
          width = Math.max(width, maxWidth);
        else if (!width && maxWidth)
          width = maxWidth
        else if (!width)
          return;

        var children = element.children();
        if (children.length != 2)
          return;

        var countWidth = $(children[1]).outerWidth();
        $(children[0]).css('width', width - countWidth + 'px');
      }
    };
  });

})();
